import {useMemo} from 'react'
import Swal from 'sweetalert2'
import {useQueryResponseData} from './QueryResponseProvider'
import {Model} from './_models'

const buildNumericReferenceId = (exam?: Partial<Model> | null | undefined): number | null => {
  if (!exam) {
    return null
  }

  const {referenceId} = exam as any
  const parsed = typeof referenceId === 'string' ? Number(referenceId) : referenceId

  if (typeof parsed === 'number' && Number.isFinite(parsed) && parsed > 0) {
    return parsed
  }

  return null
}

export const isReferenceExam = (exam?: Partial<Model> | null | undefined): boolean => {
  const numericReferenceId = buildNumericReferenceId(exam)
  return typeof numericReferenceId === 'number' && Number.isFinite(numericReferenceId) && numericReferenceId > 0
}

export const REFERENCE_EXAM_WARNING_MESSAGE =
  'Bu sınav, başka bir sınavın alt sınavı olarak ayarlanmıştır, bu nedenle düzenleme öğrenci notlarının OBS\'ye gönderimi haricinde hiçbir işlem buradan yapılamamaktadır. Diğer işlevler için ana dersi kullanınız.'

export const showReferenceExamWarning = async () =>
  Swal.fire({
    icon: 'warning',
    title: 'Uyarı',
    text: REFERENCE_EXAM_WARNING_MESSAGE,
    confirmButtonText: 'Tamam',
  })

export const useHasReferenceExam = (): boolean => {
  const items = useQueryResponseData()

  return useMemo(() => {
    return (items || []).some((exam) => isReferenceExam(exam))
  }, [items])
}
